import React from "react";
import * as styles from "./ComparisonTable.module.scss";
import dkIcon from "../../images/campaign/dk-icon.svg";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

const markdownComponents = {
  p: ({ children }) => <p>{children}</p>,
  strong: ({ children }) => <strong>{children}</strong>,
  em: ({ children }) => <em>{children}</em>,
  a: ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-clr-blue"
    >
      {children}
    </a>
  ),
};

const ComparisonTable = ({ data }) => {
  if (!data) return null;

  const { leftHeading, rightHeading, rows } = data;

  return (
    <div className={styles.table_wrapper}>
      {/* Desktop Table */}
      <table className={styles.comparison_table_html}>
        <thead>
          <tr>
            <th>{leftHeading}</th>
            <th>
              {/* <div className={styles.dkIcon}></div> */}
              {rightHeading}
            </th>
          </tr>
        </thead>

        <tbody>
          {rows?.map((row, i) => (
            <tr key={i}>
              <td>
                <ReactMarkdown
                  components={markdownComponents}
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                >
                  {row?.leftText?.data?.leftText || ""}
                </ReactMarkdown>
              </td>
              <td>
                <ReactMarkdown
                  components={markdownComponents}
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                >
                  {row?.rightText?.data?.rightText || ""}
                </ReactMarkdown>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Mobile Layout */}
      <div className={styles.mobile_table}>
        <div className={styles.mobile_column}>
          <h4>{leftHeading}</h4>
          <ul>
            {rows?.map((row, i) => (
              <li key={i}>
                <ReactMarkdown
                  components={markdownComponents}
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                >
                  {row?.leftText?.data?.leftText || ""}
                </ReactMarkdown>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.mobile_column}>
          <div>
            {/* <img src={dkIcon} alt="Datakulture icon" /> */}
            <h4>{rightHeading}</h4>
          </div>
          <ul className={styles.mobile_column_rightText}>
            {rows?.map((row, i) => (
              <li key={i}>
                <ReactMarkdown
                  components={markdownComponents}
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeRaw]}
                >
                  {row?.rightText?.data?.rightText || ""}
                </ReactMarkdown>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ComparisonTable;
